export const VoucherStatus = {
  Loading: 0,
  Activated: 200,
  NotFound: 400,
  AlreadyActivated: 410,
  Expired: 420,
  PermissionFailed: 430,
  UserHasNoAplId: 440,
  Error: 500,
  Unauthorized: 401
}
